import React, { Dispatch, SetStateAction } from 'react';
import { OpportunitiesTableColumn } from 'modules/vendorOpportunity/list/types';
import { Nullable } from 'global';
import { useSelector } from 'react-redux';
import { VOFilters, VOFilterType } from 'modules/vendorOpportunity';
import { TableFilters } from './TableFilters';
import { Account, TableFilter } from '@trnsact/trnsact-shared-types';
import { getAvailableSetOfFilters, getSetOfDataFilterOptions } from 'modules/vendorOpportunity/list/lib';
import { setOfFiltersBase, setOfFiltersSalesRep } from 'modules/vendorOpportunity/list/constants';
import { VendorContactRoles } from 'types';
import { FilterEvent } from 'components/shared/Filters';

interface Props {
  isFiltersOpen: boolean;
  tableFilters: TableFilter[];
  allColumns: OpportunitiesTableColumn[];
  currentFilterConfig: Nullable<Partial<VOFilters>>;
  setIsFilterOpen: Dispatch<SetStateAction<boolean>>;
  onTableFiltersChanged: (filters: Partial<VOFilters>, event: FilterEvent) => void;
}

export const OpportunitiesTableFilters = ({
  allColumns,
  tableFilters,
  isFiltersOpen,
  currentFilterConfig,
  setIsFilterOpen,
  onTableFiltersChanged,
}: Props) => {
  const account = useSelector((state: any) => state.account) as Account;
  const userProfile = useSelector((state: any) => state.userProfile);

  const isPartner = account.accountType === 'Partner';
  const setOfFilters = getAvailableSetOfFilters(userProfile, isPartner);

  return (
    <TableFilters
      isOpen={isFiltersOpen}
      setOfFilters={setOfFilters}
      listOfPresets={tableFilters}
      onChanged={onTableFiltersChanged}
      onClose={() => setIsFilterOpen(false)}
      externalMeta={{
        [VOFilterType.SET_OF_DATA]: getSetOfDataFilterOptions(allColumns),
      }}
      defaultExternalFiltersValue={currentFilterConfig}
    />
  );
};
